import { Link } from "react-router-dom";
import BottomNav from "../../components/BottomNav";
import UserPageHeader from "../../components/UserPageHeader";

const OPTIONS = [
  {
    to: "/agent",
    icon: "🧑‍💼",
    name: "Agent",
    tagline: "Book on behalf of walk-in customers",
    description: "A corner shop or kiosk taking in packages from walk-in customers and booking deliveries through FastSend on their behalf.",
    fee: "₦100 flat on orders under ₦5,000, or 2% on orders ₦5,000 and above — already built into the price shown, no separate charge."
  },
  {
    to: "/fleet",
    icon: "🚚",
    name: "Fleet Owner",
    tagline: "Own multiple dispatchers",
    description: "Run several dispatchers under one login, with a rollup view of the whole fleet's jobs, wallet balances, and cash owed.",
    fee: "No extra fee — dispatchers are linked to your fleet by an admin after approval."
  },
  {
    to: "/b2b?type=b2b",
    icon: "🔌",
    name: "B2B / Partner",
    tagline: "Programmatic API access",
    description: "For platforms and integrations that need to submit delivery orders programmatically — an API key, bulk order submission, and status webhooks.",
    fee: "Standard delivery pricing — pay per order or get invoiced, your choice."
  },
  {
    to: "/b2b?type=corporate",
    icon: "🏛️",
    name: "Corporate",
    tagline: "Registered company account",
    description: "A verified company (CAC registration, official email, company address) that ships through the regular app like any customer, with a dashboard for its order list, consolidated invoices, and generating new ones — no technical integration needed.",
    fee: "Admin sets your invoice as Pay Now or Consolidated once approved."
  }
];

export default function BusinessLanding() {
  return (
    <div className="user-app">
      <BottomNav />
      <div className="user-app-main">
        <UserPageHeader backTo="/order" backLabel="Send Package" />

        <div className="page wide">
          <div className="brand-header">
            <span className="brand-logo">🏢</span>
            <span className="brand-name">Businesses</span>
            <p className="brand-tagline">Ways to work with FastSend beyond a one-off delivery</p>
          </div>

          {OPTIONS.map(opt => (
            <Link key={opt.name} to={opt.to} style={{ textDecoration: "none", color: "inherit" }}>
              <div className="delivery-card" style={{ marginBottom: "16px", cursor: "pointer" }}>
                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", gap: "12px" }}>
                  <div>
                    <div style={{ fontSize: "16px", fontWeight: 700 }}>{opt.icon} {opt.name}</div>
                    <p className="hint" style={{ marginTop: "2px" }}>{opt.tagline}</p>
                  </div>
                  <span style={{ color: "var(--text-muted)", whiteSpace: "nowrap" }}>Details →</span>
                </div>
                <p style={{ fontSize: "14px", color: "var(--text-secondary)", marginTop: "10px" }}>{opt.description}</p>
                <div className="quote-box" style={{ marginTop: "10px", padding: "10px 14px" }}>
                  <p style={{ fontSize: "12px", color: "var(--text-muted)", marginBottom: "2px" }}>Fee / Pricing</p>
                  <p style={{ fontSize: "13px" }}>{opt.fee}</p>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
